<template lang="pug">
v-layout(row :class="{ 'pa-3' : $vuetify.breakpoint.smAndUp}")
  v-card(width="100%" v-if="report")

    v-toolbar.transparent(flat card :dense="!$vuetify.breakpoint.smAndUp")
      v-tooltip(bottom)
        v-btn.my-0(icon :to="{name:'ReportController', params: {reportId: report.id}}" slot="activator")
          v-icon arrow_back
        span Назад к отчету {{ report.name }} 
      v-toolbar-title.ml-0.report-toolbar-title
        v-avatar(size="40")
          v-icon.white--text.process-default-icon(:class="report.processKey")
        span {{ report.name }}

    v-divider

    v-container.px-2.py-0.p-r.report-container(fluid grid-list-xl)
      iframe.report-iframe(id="reportIframe" v-if="iframeUrl" @load="iframeLoaded = true" :class="{ 'report-iframe-loading' : !iframeLoaded}" frameborder="0" allowtransparency :src="iframeUrl")
      div.report-iframe.report-iframe-loading(v-else)
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import jwt from 'jwt-simple'

export default {
  name: 'DashBoardController',

  props: ['reportId', 'query'],

  data() {
    return {
      iframeUrl: null,
      iframeLoaded: false,
      report: null,
      inAppBrowser: null,
      relations: {
        5:12
      }
    }
  },

  computed: {
    ...mapGetters({
      reports: 'report/reports',
      profile: 'auth/profile',
      groups: 'auth/groups',
      locations: 'auth/locations',
      processInfoDialog: 'process/processInfoDialog',
      processInfoInAppBrowser: 'process/processInfoInAppBrowser',
    }),

    goBackText() {
      let txt = 'Назад к списку отчетов'
      txt = 'Назад'
      return txt
    },
  },

  watch: {
    processInfoDialog(value) {
      // eslint-disable-next-line no-undef
      if (window.cordova !== undefined && device.platform === 'iOS' && !value) {
        this.inAppBrowser.show()
      }
    },
    reportId() {
      if (this.reports.length === 0) {
        this.getReports().then(() => {
          this.loadIframe()
        })
      } else {
        this.loadIframe()
      }
    },
  },

  created() {
    window.scrollTo(0, 0)
    if (this.reports.length === 0) {
      this.getReports().then(() => {
        this.loadIframe()
      })
    } else {
      this.loadIframe()
    }
  },

  beforeDestroy() {
    // eslint-disable-next-line no-undef
    if (window.cordova !== undefined && device.platform === 'iOS') {
      this.inAppBrowser.removeEventListener('message', this.onCordovaMessage)
      this.inAppBrowser.removeEventListener('exit', this.onCordovaExit)
      this.inAppBrowser.close()
    } else {
      window.removeEventListener('message', this.onMessage)
    }
  },

  methods: {
    ...mapActions({
      getReports: 'report/getReports',
      toggleProcessInfoDialog: 'process/toggleProcessInfoDialog',
      setSnackbar: 'tools/setSnackbar',
    }),

    goBack() {
      window.history.back()
    },

    getQuery() {      
      if (typeof this.query === 'undefined') {
        return ''
      }
      const decodedObject = {};
      const decodedPairs = decodeURIComponent(this.query).split('&');

      for (const pair of decodedPairs) {
        const [key, value] = pair.split('=');
        if(value && value !== ''){
          decodedObject[key] = isNaN(value) ? value : parseInt(value);
        }
      }

      return decodedObject;
    },

    loadIframe() {
      this.report = this.reports.find((item) => {
        if (item.related && item.related.indexOf(this.reportId) > -1 ) {
          return item
        } return false
      })

      if (!this.report) {
        this.$router.push('/report-list')
        this.setSnackbar('Нет доступа')
      }

      const query = this.getQuery()

      const encodedObject = {};

      for (const key in query) {
        const encodedKey = encodeURIComponent(key);
        encodedObject[encodedKey] = query[key];
      }

      const payload = {
        resource: { dashboard: Number(this.reportId) },
        params: encodedObject,
      }
      const token = jwt.encode(payload, process.env.METABASE_SECRET_KEY)

      const url = `${process.env.METABASE_SITE_URL}/embed/dashboard/${token}#bordered=false&titled=false`

      // eslint-disable-next-line no-undef
      if (window.cordova !== undefined && device.platform === 'iOS') {
        // eslint-disable-next-line no-undef
        this.inAppBrowser = cordova.InAppBrowser.open(url, '_blank', 'location=no,hidden=yes,usewkwebview=yes,closebuttoncolor=#FFFFFF,closebuttoncaption=Назад')
        this.inAppBrowser.addEventListener('message', this.onMessage)
        this.inAppBrowser.addEventListener('exit', this.onExit)
        this.inAppBrowser.show()
      } else {
        this.iframeUrl = url
        window.addEventListener('message', this.onMessage)
      }
    },

    onExit() {
      this.$router.push('/report-list')
    },

    onMessage(event) {
      // eslint-disable-next-line no-undef
      if (window.cordova !== undefined && device.platform === 'iOS') {
        this.inAppBrowser.hide()
      }
      if (event && event.data && event.data.type && event.data.type === 'link_clicked') {
        this.$refs.processInfo.show(event.data.body.process_id)
      } else if (event && event.data && event.data.type && event.data.type === 'report_link_clicked') {
        // eslint-disable-next-line no-undef
        if (window.cordova !== undefined && device.platform === 'iOS') {
          this.inAppBrowser.close()
        }
        this.$router.push({ name: 'ReportController', params: { reportId: event.data.body.report_id } })
      }
    },
  },

  beforeRouteLeave(to, from, next) {
    if (this.processInfoDialog) {
      this.toggleProcessInfoDialog(false)
      next(false)
    } else {
      next(true)
    }
  },
}
</script>

<style lang="stylus">
.report-toolbar-title {
  .v-avatar {
    vertical-align: text-bottom;
  }

  span {
    display: inline;
    padding-left: 14px;
    vertical-align: super;
  }
}

.report-iframe {
  display: block;
  width: 100%;
  height: 100vh;
}

.report-iframe-loading {
  background: url('/static/icons/loading_spinner.gif') center no-repeat;
}

.report-container {
  background-color: #F9FBFC !important;
}
</style>



// WEBPACK FOOTER //
// src/components/report/DashBoardController.vue